<template>
  <div class="share-common-footer" v-if="isShow">
    <div class="share-common-footer-title">
      <span>分享至</span>
    </div>
    <div class="share-common-footer-list">
      <template v-if="isInApp">
        <div class="share-common-footer-list-item" @click="$emit('sharePyq')">
          <img class="tips_icon" src="@/assets/images/sharePYQ.png" />
          <span>朋友圈</span>
        </div>
        <div class="share-common-footer-list-item" @click="$emit('shareWx')">
          <img class="tips_icon" src="@/assets/images/shareWX.png" />
          <span>微信好友</span>
        </div>
      </template>
      <template v-if="!isUrl">
        <div class="share-common-footer-list-item" @click="$emit('shareCard')">
          <img class="tips_icon" src="@/assets/images/shareImg.png" />
          <span>分享海报</span>
        </div>
        <div class="share-common-footer-list-item copy" @click="shareLink">
          <img class="tips_icon" src="@/assets/images/shareLink.png" />
          <span>复制链接</span>
        </div>
      </template>
      <!-- <div class="share-common-footer-list-item" @click="$emit('shareCard')">
        <img class="tips_icon" src="@/assets/images/shareImg.png" />
        <span>分享海报</span>
      </div>
      <div class="share-common-footer-list-item copy" @click="shareLink">
        <img class="tips_icon" src="@/assets/images/shareLink.png" />
        <span>复制链接</span>
      </div>-->
    </div>
    <div class="share-common-footer-cancle" @click="$emit('cancle')">
      <span>取消</span>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant'
export default {
    props: {
        isShow: {},
        isUrl: {},
        link: {}
    },
    computed: {
        isInApp() {
            return navigator.userAgent.indexOf('YPAPP') !== -1
        }
    },
    mounted() {
        import('@utils/clipboard.min.js')
    },
    methods: {
        shareLink() {
            import('@utils/clipboard.min.js').then(res => {
                const clipboard = new res.default('.copy', {
                    text: _ => window.location.href
                })
                clipboard.on(
                    'success',
                    function(e) {
                        Toast('复制成功')
                        this.$emit('shareLink')
                        e.clearSelection()
                    }.bind(this)
                )
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.share-common-footer {
    display: flex;
    align-items: center;
    flex-direction: column;
    width: 100%;
    height: calc(1.75rem + 4.27rem+ 1.88rem);
    .share-common-footer-title {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 1.75rem;
        background: #f1f1f5;
        border-radius: 0.51rem 0.51rem 0rem 0rem;
        border-bottom: 0.03px solid #dedede;
        span {
            font-size: 0.6rem;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.65);
        }
    }
    .share-common-footer-list {
        width: 100%;
        padding: 0.6rem 2.14rem;
        display: flex;
        align-items: center;
        justify-content: space-around;
        height: 4.67rem;
        background: #f1f1f5;
        .share-common-footer-list-item {
            cursor: pointer;
            display: flex;
            align-items: center;
            flex-direction: column;
            width: 2.14rem;
            height: 2.14rem;
            border-radius: 100%;
            background: #ffffff;
            img {
                width: 2.14rem;
                height: 2.14rem;
                border-radius: 100%;
            }
            span {
                margin-top: 0.21rem;
                font-size: 0.51rem;
                font-weight: 400;
                color: rgba(0, 0, 0, 0.65);
            }
        }
    }
    .share-common-footer-cancle {
        cursor: pointer;
        width: 100%;
        height: 1.88rem;
        background: #ffffff;
        display: flex;
        align-items: center;
        justify-content: center;
        span {
            font-size: 0.6rem;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #888888;
        }
    }
}
</style>